<template>
  <div class="asc-report-menu">
    <v-menu
      v-model="model"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
      content-class="asc-report-menu--menu-list"
      v-on="$listeners"
    >
      <v-list>
        <template v-if="hasParameterAlert">
          <div class="asc-report-menu--menu-list-heading">Alerts</div>
          <v-list-item @click="handleParameterAlertClick">
            <v-list-item-title>
              <asc-parameter-alert-item
                :status="status"
              ></asc-parameter-alert-item>
            </v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
        </template>
        <template v-if="hasFaultMonitorAlert">
          <div class="asc-report-menu--menu-list-heading">Fault Monitors</div>
          <v-list-item
            v-for="(item, index) in faultMonitors"
            :key="index"
            @click="handleFaultMonitorAlertClick(item.faultMonitorId)"
          >
            <v-list-item-title>
              {{ item.title }}
            </v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
        </template>
        <v-list-item @click="handleParameterDefinitionClick">
          <v-list-item-title>Parameter Definition</v-list-item-title>
        </v-list-item>
        <template v-if="plottable">
          <v-list-item @click="handleParameterGraphClick">
            <v-list-item-title>Parameter Graph</v-list-item-title>
          </v-list-item>
          <v-list-item @click="handleFleetGraphClick">
            <v-list-item-title>Fleet Graph</v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import {
  AscFaultMonitorAlertMixin,
  AscFleetGraphMixin,
  AscParameterAlertMixin,
  AscParameterDefinitionMixin,
  AscParameterGraphMixin,
  AscStatusPropsMixin,
} from '@/components/mixins'
import AscParameterAlertItem from './AscParameterAlertItem'

export default {
  name: 'AscReportMenu',

  components: {
    AscParameterAlertItem,
  },

  mixins: [
    AscFaultMonitorAlertMixin,
    AscFleetGraphMixin,
    AscParameterAlertMixin,
    AscParameterDefinitionMixin,
    AscParameterGraphMixin,
    AscStatusPropsMixin,
  ],

  props: {
    onMenuClose: {
      type: Function,
      required: true,
    },
    alertEnabled: {
      type: Boolean,
      default: false,
    },
    plottable: {
      type: Boolean,
      default: true,
    },
    showMenu: {
      type: Boolean,
      default: false,
    },
    x: {
      type: Number,
      default: 0,
    },
    y: {
      type: Number,
      default: 0,
    },
    faultMonitors: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      viewModel: this.showMenu,
    }
  },

  computed: {
    model: {
      get() {
        return this.viewModel
      },
      set(newValue) {
        if (!newValue) {
          if (this.onMenuClose) {
            this.onMenuClose()
          }
        }
        this.viewModel = newValue
      },
    },
  },

  watch: {
    showMenu(newVal) {
      this.viewModel = newVal
    },
  },

  methods: {
    handleFaultMonitorAlertClick(event) {
      if (this.onFaultMonitorAlertClick) {
        this.onFaultMonitorAlertClick(event)
      }
    },
    handleParameterAlertClick(event) {
      if (this.onParameterAlertClick) {
        this.onParameterAlertClick(event)
      }
    },
    handleParameterDefinitionClick(event) {
      if (this.onParameterDefinitionClick) {
        this.onParameterDefinitionClick(event)
      }
    },
    handleParameterGraphClick(event) {
      if (this.onParameterGraphClick) {
        this.onParameterGraphClick(event)
      }
    },
    handleFleetGraphClick(event) {
      if (this.onFleetGraphClick) {
        this.onFleetGraphClick(event)
      }
    },
  },
}
</script>

<style lang="scss">
.asc-report-menu--menu-list {
  & .v-list-item {
    border-left: 4px solid transparent;

    &:hover {
      border-left: 4px solid $gray-100;
      text-decoration: none;
      cursor: pointer;
      background-color: $gray-100 !important;
      color: $primary-black;
    }
  }

  & .v-list > div {
    background-color: $primary-white;
  }

  & .v-list-item--link {
    color: inherit;
    font-size: 14px;
  }

  & .v-list {
    padding: 0;
    max-height: 365px;
  }
}

.asc-report-menu--menu-list-heading {
  font-weight: bold;
  margin-left: 15px;
}
</style>
